import React, { useState } from 'react';
import { 
  FaCheckCircle, FaBullseye, FaMapPin, FaCogs, 
  FaSyncAlt, FaChartLine, FaLightbulb, FaChartBar, FaLock, 
  FaLink, FaCloud, FaClock, FaDollarSign, FaGlobeAmericas, 
  FaHandshake, FaStar, FaFacebook, FaTwitter, FaLinkedin, FaInstagram
} from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import SEOHelmet from '../SEOHelmet';
import Navbar from './Navbar';
import '../../styles/landing-page/WhyAssetflow.css';
import HeroSectionImg1 from '../../assets/Whyassetflow.png';
import ctaimage1 from '../../assets/Mobileview.png';
import ctaimage2 from '../../assets/AdminDashboard2.png';
import WhyAssetflowImg from '../../assets/WhyAssetflow2.png';
import WhyAssetflowImg3 from '../../assets/WhyAssetFlow3.png';
const WhyAssetflowPage = () => {
  const navigate = useNavigate();
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [expandedFAQ, setExpandedFAQ] = useState(null);
  const [activeSection, setActiveSection] = useState('WhyAssetFlows');

  const iconMap = {
    FaBullseye, FaMapPin, FaCogs, FaSyncAlt, FaChartLine, 
    FaLightbulb, FaChartBar, FaLock, FaLink, FaCloud, 
    FaClock, FaDollarSign, FaGlobeAmericas, FaHandshake, FaStar
  };

  const reasons = [
    {
      id: 1,
      title: "Fully Customized Solutions",
      icon: "FaBullseye",
      description: "Assets Flow offers tailored asset management software based on specific business needs. This ensures companies get exactly what they require instead of adjusting to generic systems, making it ideal for diverse industries.",
      benefits: ["Personalized Setup", "Industry-Specific Features", "Custom Workflows"]
    },
    {
      id: 2,
      title: "Real-Time Asset Tracking",
      icon: "FaMapPin",
      description: "With Assets Flow, businesses can track assets in real-time using advanced technologies. This improves visibility, reduces asset loss, and ensures better accountability across departments.",
      benefits: ["Live Location Updates", "GPS Integration", "Instant Alerts"]
    },
    {
      id: 3,
      title: "Centralized Asset Control",
      icon: "FaCogs",
      description: "Assets Flow provides a single dashboard to manage all assets from one place. This eliminates data silos and helps organizations make faster and more informed decisions.",
      benefits: ["Unified Dashboard", "All-in-One Control", "Real-Time Insights"]
    },
    {
      id: 4,
      title: "Complete Asset Lifecycle Management",
      icon: "FaSyncAlt",
      description: "From procurement to disposal, Assets Flow manages the entire lifecycle of assets. This helps in tracking depreciation, maintenance schedules, and overall asset performance efficiently.",
      benefits: ["Acquisition to Disposal", "Depreciation Tracking", "Maintenance Scheduling"]
    },
    {
      id: 5,
      title: "Scalable for Growing Businesses",
      icon: "FaChartLine",
      description: "Assets Flow is designed to scale with your business. Whether you're a startup or an enterprise, the system adapts to your growth without performance issues.",
      benefits: ["Unlimited Assets", "Multi-Location Support", "Growth-Ready Architecture"]
    },

    {
      id: 7,
      title: "Advanced Reporting & Analytics",
      icon: "FaChartBar",
      description: "Assets Flow provides detailed reports and analytics that help businesses understand asset utilization, costs, and performance, enabling data-driven decision-making.",
      benefits: ["Custom Reports", "Predictive Analytics", "Data Visualization"]
    },
    {
      id: 8,
      title: "Strong Security & Access Control",
      icon: "FaLock",
      description: "With role-based access and secure data handling, Assets Flow ensures that only authorized users can access sensitive asset information, maintaining high security standards.",
      benefits: ["Role-Based Access", "Encryption", "Audit Trails"]
    },
    {
      id: 9,
      title: "Seamless Integration",
      icon: "FaLink",
      description: "Assets Flow easily integrates with ERP, CRM, and other enterprise systems. This ensures smooth workflow automation and better coordination across business processes.",
      benefits: ["ERP Integration", "API Access", "Third-Party Tools Support"]
    },
   
    {
      id: 11,
      title: "Automated Alerts & Maintenance Tracking",
      icon: "FaClock",
      description: "Assets Flow sends automated alerts for maintenance, warranty expiry, and asset audits. This helps prevent downtime and extends asset life.",
      benefits: ["Smart Notifications", "Preventive Maintenance", "Automated Audits"]
    },

    {
      id: 13,
      title: "Multi-Location Asset Management",
      icon: "FaGlobeAmericas",
      description: "Businesses can track and manage assets across multiple branches or locations from a single platform, ensuring consistency and control.",
      benefits: ["Branch Management", "Inventory Sync", "Centralized Control"]
    }
  ];

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div className="why-assetflow-page">
      <SEOHelmet page="whyAssetFlows" canonicalUrl="https://www.assetflows.in/why-assetflow" />
      {/* Header Section */}
      <header className="why-header">
        <Navbar activeSection={activeSection} setActiveSection={setActiveSection} />
        <div className="why-header__content">
          <div className="why-header__left">
            <h1 className='heading-yellow'>Why Choose Assets Flow?</h1>
            <p>Discover why thousands of businesses trust Assets Flow for comprehensive asset management solutions</p>
          </div>
          <div className="why-header__right">
            <div className="dashboard-images">
              <img 
                src={HeroSectionImg1} 
                alt="Dashboard View" 
                className="dashboard-img dashboard-img--primary"
              />
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="why-main">
        {/* Hero Section */}
        <section className="why-hero-section">
          <div className="why-container">
            <div className="why-hero-wrapper">
              <div className="why-hero-images">
                <div className="why-hero-image-container">
                  <img src={WhyAssetflowImg3} alt="Asset Management 1" className="why-hero-img-primary" />
                  <img src={WhyAssetflowImg} alt="Asset Management 2" className="why-hero-img-secondary" />
                </div>
              </div>
              <div className="why-hero-content">
                <h2> Complete Asset Management Platform</h2>
                <p>
                  Assets Flow is revolutionizing how organizations manage their assets. From small startups to large enterprises, 
                  our platform provides the comprehensive tools needed to optimize asset management across your entire organization.
                </p>
                <div className="why-hero-stats">
                  <div className="stat">
                    <h3>10,000+</h3>
                    <p>Active Users</p>
                  </div>
                  <div className="stat">
                    <h3>15+</h3>
                    <p>Industries</p>
                  </div>
                  <div className="stat">
                    <h3>99.9%</h3>
                    <p>Uptime</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Reasons Grid */}
        <section className="why-reasons-section">
          <div className="why-container">
            <h2 className="section-title">10 Reasons to Choose Assets Flow</h2>
            
            <div className="why-reasons-grid">
              {reasons.map((reason, index) => (
                <div 
                  key={reason.id} 
                  className={`why-card ${expandedIndex === index ? 'expanded' : ''}`}
                  onClick={() => toggleExpand(index)}
                >
                  <div className="why-card__header">
                    <div className="why-card__icon">
                      {React.createElement(iconMap[reason.icon])}
                    </div>
                    <div className="why-card__title-section">
                      <h3>{reason.title}</h3>
                      <span className="why-card__number">#{reason.id}</span>
                    </div>
                      <p >{reason.description}</p>
                  </div>

                  {expandedIndex === index && (
                    <div className="why-card__expanded">
                      <p className="why-card__description">{reason.description}</p>
                      <div className="why-card__benefits">
                        <h4>Key Benefits:</h4>
                        <ul>
                          {reason.benefits.map((benefit, idx) => (
                            <li key={idx}>
                              <FaCheckCircle className="check-icon" />
                              {benefit}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Comparison Section */}
        <section className="why-comparison-section">
          <div className="why-container">
            <h2 className="section-title">Assets Flow vs. Generic Solutions</h2>
            <div className="why-comparison-flex">
              <div className="why-comparison-images">
                <img src={ctaimage1} alt="Mobile View" className="why-comparison-img why-comparison-img--mobile" />
                <img src={ctaimage2} alt="Laptop View" className="why-comparison-img why-comparison-img--laptop" />
              </div>
              <div className="comparison-table-wrapper">
                <div className="comparison-table">
                  <table>
                    <thead>
                      <tr>
                        <th>Feature</th>
                        <th>Assets Flow</th>
                        <th>Generic Solutions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="positive">
                        <td>Customization</td>
                        <td><span className="why-badge badge--yes">Fully Customizable</span></td>
                        <td><span className="why-badge badge--no">Limited</span></td>
                      </tr>
                      <tr className="positive">
                        <td>Real-Time Tracking</td>
                        <td><span className="why-badge badge--yes">✓ Yes</span></td>
                        <td><span className="why-badge badge--no">✗ No</span></td>
                      </tr>
                      <tr className="positive">
                        <td>Scalability</td>
                        <td><span className="why-badge badge--yes">Enterprise Ready</span></td>
                        <td><span className="why-badge badge--no">Limited Scale</span></td>
                      </tr>
                      <tr className="positive">
                        <td>Support</td>
                        <td><span className="why-badge badge--yes">24/7 Support</span></td>
                        <td><span className="why-badge badge--no">Business Hours</span></td>
                      </tr>
                      <tr className="positive">
                        <td>Integration</td>
                        <td><span className="why-badge badge--yes">Seamless</span></td>
                        <td><span className="why-badge badge--no">Complex</span></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>

      

        {/* FAQ Section */}
        <section className="why-faq-section">
          <div className="why-container">
            <h2 className="section-title">Frequently Asked Questions</h2>
            
            <div className="faq-accordion">
              {[
                {
                  id: 1,
                  question: "Can Assets Flow handle multi-location tracking?",
                  answer: "Yes! Assets Flow is designed specifically for managing assets across multiple branches and locations. You get a unified view of all assets from any location with real-time updates and centralized control."
                },
                {
                  id: 2,
                  question: "What industries does Assets Flow serve?",
                  answer: "Assets Flow is trusted by IT, healthcare, education, manufacturing, retail, government, and many other sectors. Our platform is highly customizable for any industry-specific requirements and workflows."
                },
                {
                  id: 3,
                  question: "Is the platform secure?",
                  answer: "Absolutely. Assets Flow uses enterprise-grade encryption, role-based access control, and regular security audits. Your data is protected at all times with compliance to industry standards."
                },
                {
                  id: 4,
                  question: "How easy is it to migrate from my current system?",
                  answer: "Our team provides complete migration support. We handle data import, setup, and training to ensure a smooth transition with zero downtime for your operations."
                }
              ].map((faq) => (
                <div
                  key={faq.id}
                  className={`faq-item ${expandedFAQ === faq.id ? 'active' : ''}`}
                >
                  <button
                    className="faq-question"
                    onClick={() => setExpandedFAQ(expandedFAQ === faq.id ? null : faq.id)}
                    type="button"
                  >
                    <span>{faq.question}</span>
                    <span className="faq-arrow" />
                  </button>
                  {expandedFAQ === faq.id && (
                    <div className="faq-answer">
                      <p>{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>


        {/* CTA Section (copied from PricingPage for pixel-perfect match, text preserved) */}
        <section className="pricing-cta">
          <div className="pricing-cta-content">
            <div className="pricing-cta-left">
              <h2>Ready to Transform Your Asset Management?</h2>
              <p>Start your journey with Assets Flow today and experience the difference a comprehensive asset management solution can make.</p>
              <button onClick={() => navigate('/pricing')}>View Pricing Plans</button>
            </div>
            <div className="pricing-cta-right">
              <div className="cta-mockup-container">
                <div className="cta-mockup-mobile">
                  <img src={ctaimage1} alt="Mobile View" />
                </div>
                <div className="cta-mockup-laptop">
                  <img src={ctaimage2} alt="Laptop View" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FOOTER SECTION (copied from PricingPage for pixel-perfect match) */}
        <footer className="pricing-footer">
          <div className="footer-content">
            <div className="footer-grid">
              {/* Brand Section */}
              <div className="footer-section">
                <div className="footer-brand">
                  <span>📦</span>
                  <span>AssetFlows</span>
                </div>
                <p className="footer-description">
                  The most comprehensive, user-friendly asset management platform trusted by 5,000+ organizations worldwide. 
                  From startups to Fortune 500 companies, AssetFlows is the smart choice for intelligent asset management, 
                  maintenance tracking, and operational excellence.
                </p>
                <div className="footer-social">
                  <button onClick={() => {}} title="Facebook" className="icon-btn"><FaFacebook /></button>
                  <button onClick={() => {}} title="Twitter" className="icon-btn"><FaTwitter /></button>
                  <button onClick={() => {}} title="LinkedIn" className="icon-btn"><FaLinkedin /></button>
                  <button onClick={() => {}} title="Instagram" className="icon-btn"><FaInstagram /></button>
                </div>
              </div>

              {/* Product Section */}
              <div className="footer-section">
                <h4>Product</h4>
                <ul>
                  <li><a href="/pricing" onClick={() => navigate('/pricing')}>Pricing</a></li>
                  <li><a href="/why-assetflow" onClick={() => navigate('/why-assetflow')}>Why AssetFlows</a></li>
                  <li><span>Features</span></li>
                  <li><span>Security</span></li>
                  <li><span>Integrations</span></li>
                </ul>
              </div>

              {/* Company Section */}
              <div className="footer-section">
                <h4>Company</h4>
                <ul>
                  <li><span>About Us</span></li>
                  <li><span>Blog</span></li>
                  <li><span>Careers</span></li>
                  <li><span>Contact</span></li>
                  <li><span>Partners</span></li>
                </ul>
              </div>

              {/* Resources Section */}
              <div className="footer-section">
                <h4>Resources</h4>
                <ul>
                  <li><span>Documentation</span></li>
                  <li><span>Support</span></li>
                  <li><span>FAQ</span></li>
                  <li><span>Community</span></li>
                  <li><span>Status</span></li>
                </ul>
              </div>
            </div>

            {/* Divider */}
            <div className="footer-divider"></div>

            {/* Bottom Footer */}
            <div className="footer-bottom">
              <p>&copy; 2024 AssetFlows. All rights reserved.</p>
              <div className="footer-links">
                <button onClick={() => {}} className="footer-link-btn">Privacy Policy</button>
                <button onClick={() => {}} className="footer-link-btn">Terms of Service</button>
                <button onClick={() => {}} className="footer-link-btn">Cookie Policy</button>
                <button onClick={() => {}} className="footer-link-btn">Security</button>
              </div>
            </div>
          </div>
        </footer>
      </main>
    </div>
  );
};

export default WhyAssetflowPage;
